export  class Constants{

// baseUrl = "http://xyzcad.nn.mt.cisinlive.com/";
static baseUrl = "https://xyzcad.co.uk/";
//static baseUrl = "http://localhost:44372/";
static apiUrl = Constants.baseUrl + "api/";
}
